import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  IComment,
  ICommentActionEvent,
} from 'src/app/models_new/types/comment';
import { IHasuraUser } from 'src/app/models_new/types/hasura-user';
import { Role } from 'src/app/models_new/types/role';
import { SimulationType } from 'src/app/services/api/comment-api.service';
import { timeDifferenceApprox } from 'src/app/utils/time-utils';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss'],
})
export class CommentComponent implements OnInit {
  @Input() comment: IComment;
  @Input() isPublic?: boolean = false;
  @Input() user: IHasuraUser;
  @Input() accessMode?: SimulationType = SimulationType.PUBLIC;
  @Input() userLoggedTopRole: Role = 'public';
  @Output() actionComment?: EventEmitter<ICommentActionEvent> =
    new EventEmitter();

  ngOnInit(): void {
    this.comment.timeSince =
      timeDifferenceApprox(
        new Date(Date.now()).getTime(),
        new Date(this.comment.created_at).getTime()
      ) + ' ago';
  }

  /**
   * Handles all possible actions related to the comment field.
   * @Input EventType => Event type to be triggered [POST | UPDATE | DELETE]
   * @Input $Event => Text content <string> of the comment
   * @Input id => if eventType == POST, id = parent_id, if eventType == UPDATE : id = comment_id
   */
  public triggerEvent(
    eventType: ICommentActionEvent['event'],
    $event,
    id?: string,
    role?: Role
  ): void {
    switch (eventType) {
      case 'post':
        this.actionComment.emit({
          event: eventType,
          comment_reply: {
            parent_id: id,
            comment: $event.comment,
            public_user: $event.public_user,
          },
        });
        break;
      case 'update':
        this.actionComment.emit({
          event: eventType,
          comment_id: id,
          comment_reply: { comment: $event.comment },
        });
        break;
      case 'delete':
      case 'expand':
      case 'reply':
        this.actionComment.emit({
          event: eventType,
          comment_id: id,
          role: role,
        });
        break;
    }
  }
}
